/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostClippingPastArticleResearchBillingSuccessResponse
 */
export interface PostClippingPastArticleResearchBillingSuccessResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof PostClippingPastArticleResearchBillingSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostClippingPastArticleResearchBillingSuccessResponse
     */
    message: string;
}

export function PostClippingPastArticleResearchBillingSuccessResponseFromJSON(json: any): PostClippingPastArticleResearchBillingSuccessResponse {
    return PostClippingPastArticleResearchBillingSuccessResponseFromJSONTyped(json, false);
}

export function PostClippingPastArticleResearchBillingSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostClippingPastArticleResearchBillingSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostClippingPastArticleResearchBillingSuccessResponseToJSON(value?: PostClippingPastArticleResearchBillingSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

